/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable no-else-return */
/* eslint-disable sonarjs/no-ignored-return */
/* eslint-disable sonarjs/cognitive-complexity */
import { useMsal } from "@azure/msal-react";
import { Draggable } from "@fullcalendar/interaction";
import { addMinutes, format, isAfter, isBefore, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { Prompt, useLocation } from "react-router-dom";
import uuid from "react-uuid";
import moment from "moment";
import { ThemeProvider } from "styled-components";
import {
    applyValidation,
    checkHolidayCard,
    checkAbonoCard,
    hourRangeExceededForOvertimeCards,
} from "../../utils/validationFunctions";
import {
    getEnumByLabel,
    isCampusHoliday,
    isNationalHoliday,
    isAbono,
} from "../../utils/StatusCheckinUtils";

import usePromisifiedDialog from "../../hooks/UsePromisifiedDialog";
import {
    IPromisifiedDialogProps,
    PromisifiedDialog,
} from "../../components/PromisifiedDialog/PromisifiedDialog";

import { axiosGetRequest, axiosPatchRequest } from "../../api/ApiClient";
import { ReactComponent as FileExtractIcon } from "../../assets/icons/FileExtract.svg";
import { ReactComponent as InformationModal } from "../../assets/icons/InformationModal.svg";
import { ReactComponent as SuccessModal } from "../../assets/icons/SuccessModal.svg";
import { ReactComponent as LeftArrow } from "../../assets/icons/chevrons-left-regular.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/chevrons-right-regular.svg";
import Autocomplete from "../../components/Autocomplete";
import Dialog from "../../components/Dialog";
import DialogMessage from "../../components/DialogMessage";
import DialogMessageList from "../../components/DialogMessageList";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { InformationIcon, PrintReportIcon } from "../../components/Icons";
import Schedule from "../../components/Schedule";
import { ptBrTranslations } from "../../i18n/locales/pt-br";
import DialogMessageProps from "../../model/DialogMessageProps";
import AgendaDTO from "../../model/dto/AgendaDTO";
import AgendaSalvarDTO from "../../model/dto/AgendaSalvarDTO";
import BacklogDTO from "../../model/dto/BacklogDTO";
import Cartao from "../../model/dto/Cartao";
import CartaoDTO from "../../model/dto/CartaoDTO";
import { PlanoAtividadeStatusEnum } from "../../model/Enums/PlanoAtividadeStatusEnum";
import { Roles } from "../../model/Enums/RolesEnum";
import { Routes } from "../../model/Enums/RoutesEnum";
import { useNotification } from "../../context/NotificationContext";
import {
    getLabelTipoCartaoEnum,
    isOvertimeCard,
    TipoCartaoEnum,
} from "../../model/Enums/TipoCartaoEnum";
import {
    TipoHoraEnum,
    TipoHoraEnumLabel,
} from "../../model/Enums/TipoHoraEnum";
import { TipoNotificacaoEnum } from "../../model/Enums/TipoNotificacaoEnum";
import { TypeDialogMessageEnum } from "../../model/Enums/TypeDialogMessageEnum";
import ModalCallback from "../../model/ModalCallback";
import ActivityPlanService from "../../service/Docente/ActivityPlanService";
import CartoesService from "../../service/Docente/CartoesService";
import HolidayService from "../../service/Docente/HolidayService";
import NotificationService from "../../service/Docente/NotificationService";
import ScheduleService from "../../service/Docente/ScheduleService";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import { StyledBody, StyledHeader, StyledTitle } from "../../styles/MainStyles";
import {
    StyledCardEmptyResult,
    StyledExternalEvents,
    StyledScheduleContainer,
    StyledTitleContainer,
    ButtonWrapper,
    StyledBacklogTitle,
    StyledBacklogPhrase,
    StyledActivityHeaderDiv,
    StyledBacklogDiv,
    StyledScheduleDiv,
    StyledExtractButton,
    StyledBacklogTitleContainer,
    StyledHeaderRow,
    StyledBacklogPhraseContainer,
    ToggleExpandButtonRight,
    ToggleExpandButtonCenter,
} from "../../styles/pages/Schedule/ScheduleStyle";
import {
    MASK_DATE,
    MASK_DATE_BR,
    MASK_TIME,
    MASK_TIMESTAMP,
    RECREATION,
    promptMessage,
} from "../../utils/constants";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import ModalCreateCard from "./ModalCreateCard/ModalCreateCard";
import ModalHourExtract from "./ModalHourExtract";
import ModalRequestJustification from "./ModalRequestJustification";
import ModalViewDetails from "./ModalViewDetails";
import ScheduleCards from "./ScheduleCards";
import {
    StatusCheckinEnum,
    StatusCheckinEnumLabel,
} from "../../model/Enums/StatusCheckinEnum";
import { ValidationResult } from "../../utils/types/ValidationResult";
import ModalReport from "./ModalReport";
import ModalScheduleBlock from "./ModalScheduleBlock";
import ProfessorService from "../../service/Docente/ProfessorService";
import { ProfessorStatusEnum } from "../../model/Enums/ProfessorStatusEnum";
import { VigenciaPlanoAtividade } from "../../model/dto/VigenciaPlanoAtividade";
import DateUtils from "../../utils/DateUtils";

function adjustCardName(name: string): string {
    return name === "Hora extra" ? "Hora Letiva RE" : name;
}
const { BtnPrimary, DefaultButtonLink, BtnOutlinePrimary } = ButtonStyles;
const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;

const CARD_NOT_MOVED = "Cartão não movido";
const RECREIO = "Recreio - Estudantes";
const CARD_NOT_MOVED_BY_WORKBREAK =
    "Não é possível alocar um cartão dentro do período de afastamento do docente";

type HasExceededLimit = {
    exceededYesterdayCards: any[];
    exceededTomorrowCards: any[];
};

let timer: any;

function ScheduleView() {
    const { instance } = useMsal();

    const location = useLocation();
    const pathLocation = location.pathname.split("/");

    const user = GenericUtils.getUser();
    const user1 = JSON.parse(localStorage.getItem("user") ?? "{}");
    const acessToken = GenericUtils.getAccessTokenDocente();

    const draggableEl = document.getElementById("external-events");

    const [initialDate, setInitialDate] = useState("");
    const [finalDate, setFinalDate] = useState("");
    const [schedulesEvents, setScheduleEvents] = useState<any[]>([]);
    const [schedulesEventsCash, setScheduleEventsCash] = useState<any[]>([]);
    const [backlog, setBacklog] = useState<any[]>([]);
    const [cashBacklog, setCashBacklog] = useState(new Array<BacklogDTO>());
    const [validActivePlan, setValidActivyPlan] = useState<
        Array<VigenciaPlanoAtividade>
    >([] as Array<VigenciaPlanoAtividade>);
    const [holidays, setHolidays] = useState<any[]>([]);
    const [dataAbonos, setDataAbonos] = useState<any[]>([]);
    const [paramsAgenda, setParamsAgenda] = useState({});
    const [viewType, setViewType] = useState("");
    const [selected, setSelected] = useState<any[]>([]);
    const [cleanEvents, setCleanEvents] = useState<number>(0);
    const [disableSave, setDisableSave] = useState<boolean>(true);
    const [teachers, setTeachers] = useState<any[]>([]);
    const [getTeachers, setGetTeachers] = useState<any[]>([]);
    const [selectTeachers, setSelectTeachers] = useState<any>();
    const [blockActivy, setBlockActivity] = useState(false);
    const [reportDialog, setReportDialog] = useState(false);
    const [blockByAfastamento, setBlockByAfastamento] = useState(false);
    const [sobreposto, setSobreposto] = useState(false);
    const [dataPick, setDataPick] = useState("");
    const [vigencia, setVigencia] = useState([]);
    const [firstDateCards, setFirstDateCards] = useState<Date>(new Date());
    const [endDateCards, setEndDateCards] = useState<Date>(new Date());
    // Modal create card
    const [openModalCreateCard, setOpenModalCreateCard] = useState(false);
    // Modal view details
    const [scheduleSelected, setScheduleSelected] = useState<any>();
    const [linkedCard, setLinkedCard] = useState<{
        linkedCardType: TipoCartaoEnum | 0;
        linkedCardAllocationDate: string;
    }>({
        linkedCardType: 0,
        linkedCardAllocationDate: "",
    });
    // Modal request justification
    const [openModalRequestJustification, setOpenModalRequestJustification] =
        useState(false);
    const [replicateValidity, setReplicateValidity] = useState(false);
    // Modal hours extract
    const [openModalHourExtract, setOpenModalHourExtract] = useState(false);
    // Dialog
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorText, setErrorText] = useState<string | undefined>("");
    // Dialog notification
    const { notifications, setNotifications } = useNotification();
    // Dialog questionSave
    const [openDialogQuestionSave, setOpenDialogQuestionSave] = useState(false);
    const [validTurn, setValidTurn] = useState(false);
    const [openDialogCheckinSucess, setOpenDialogCheckinSucess] =
        useState(false);
    // Dialog Schedule Block
    const [openDialogScheduleIcons, setOpenDialogScheduleIcons] =
        useState(false);
    const [openDialogScheduleBlock, setOpenDialogScheduleBlock] =
        useState(false);
    const autocompleteElement =
        document.getElementsByClassName("autocomplete")[0];
    const [contentIsHtml, setContentIsHtml] = useState<boolean>(false);
    const [removedIntrajourneyCards, setRemovedIntrajourneyCards] = useState<
        number[]
    >([]);
    const [scheduleHasSpecialCards, setScheduleHasSpecialCards] =
        useState<boolean>(false);
    const [hide, setHide] = useState<boolean>(false);

    function debounce(func: any, timeout = 300) {
        return (...args: any[]) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func(...args);
            }, timeout);
        };
    }

    const debouncedRefreshScheduleData = debounce(refreshScheduleData, 1000);

    let hasHourRangeExceededForOvertimeCards = {
        exceededYesterdayCards: [],
        exceededTomorrowCards: [],
    } as HasExceededLimit;

    const promisifiedDialog = usePromisifiedDialog<
        IPromisifiedDialogProps,
        boolean
    >(PromisifiedDialog);

    const getMatriculaAdp = () => {
        return pathLocation[1] !== Routes.MinhaAgenda
            ? selectTeachers?.matriculaAdp
            : user?.docente?.matriculaAdp;
    };

    const getSelectedDocente = () => {
        return pathLocation[1] !== Routes.MinhaAgenda
            ? selectTeachers
            : user?.docente;
    };

    const getRole = () => {
        return !!user?.listaFuncionalidades?.find(
            (item: any) => item?.mnemonico === Roles.EDITAR_AGENDA_DOCENTE
        );
    };

    const getRoleConsult = () => {
        return !!user?.listaFuncionalidades?.find(
            (item: any) => item?.mnemonico === Roles.VISUALIZAR_AGENDA_DOCENTE
        );
    };

    const isMyProfile =
        getRoleConsult() &&
        selectTeachers?.matriculaAdp === user?.docente?.matriculaAdp;

    const isNotEditable = () => {
        if (getRole()) {
            return false;
        }

        return (
            getRoleConsult() &&
            selectTeachers?.matriculaAdp !== user?.docente?.matriculaAdp
        );
    };

    const isNotEditableProfile = isNotEditable();

    const theme = {
        width: getRoleConsult() ? "100% !important" : "911px",
    };

    const getBackgroundColor = (type: number) => {
        if (
            type === TipoCartaoEnum.HoraNaoLetiva ||
            type === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            type === TipoCartaoEnum.Esporadica
        ) {
            return "#FFD1DC";
        }
        if (type === TipoCartaoEnum.HoraLetiva) return "#D2DCFF";
        if (type === TipoCartaoEnum.Antecipacao) return "#057C84";
        if (type === TipoCartaoEnum.Substituicao) return "#3907FF";
        if (type === TipoCartaoEnum.Reposicao) return "#ff7d04";
        if (type === TipoCartaoEnum.AtividadesAvulsas) return "#FEECAA";
        if (
            type === TipoCartaoEnum.HoraExtraImportacao ||
            type === TipoCartaoEnum.HoraExtraTela
        )
            return "#DABCFF";

        return "#D5FFB1";
    };

    const getBackgroundColorAtSchedule = (
        type: number,
        typeOrigin: number,
        letiva: boolean,
        naoLetiva: boolean
    ) => {
        const typesNoTeachingCards =
            typeOrigin === TipoCartaoEnum.HoraNaoLetiva ||
            typeOrigin === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            typeOrigin === TipoCartaoEnum.Esporadica;

        if (type === TipoCartaoEnum.Intrajornada) {
            return "#D5FFB1";
        }

        if (
            (type === TipoCartaoEnum.HoraNaoLetiva ||
                type === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
                type === TipoCartaoEnum.Esporadica) &&
            typeOrigin === 0
        ) {
            return "#FFD1DC";
        }
        if (type === TipoCartaoEnum.HoraLetiva && typeOrigin === 0)
            return "#D2DCFF";
        if (type === TipoCartaoEnum.AtividadesAvulsas) return "#FEECAA";
        if (
            (type === TipoCartaoEnum.HoraExtraImportacao && typeOrigin === 0) ||
            (type === TipoCartaoEnum.HoraExtraTela && typeOrigin === 0)
        )
            return "#DABCFF";
        if (
            (type === TipoCartaoEnum.Antecipacao ||
                type === TipoCartaoEnum.Substituicao ||
                type === TipoCartaoEnum.Reposicao) &&
            typeOrigin === TipoCartaoEnum.HoraLetiva
        )
            return "#D2DCFF";
        if (
            (type === TipoCartaoEnum.Antecipacao ||
                type === TipoCartaoEnum.Substituicao ||
                type === TipoCartaoEnum.Reposicao) &&
            typesNoTeachingCards
        )
            return "#FFD1DC";

        if (
            type === TipoCartaoEnum.Reposicao &&
            typeOrigin === TipoCartaoEnum.Reposicao
        )
            return naoLetiva ? "#FFD1DC" : "#D2DCFF";

        return letiva ? "#D2DCFF" : "#FFD1DC";
    };

    const getFontColor = (type: number) => {
        if (
            type === TipoCartaoEnum.Antecipacao ||
            type === TipoCartaoEnum.Reposicao ||
            type === TipoCartaoEnum.Substituicao
        ) {
            return "#fff";
        }
        return "#404040";
    };

    const getFontColorAtSchedule = () => {
        return "#404040";
    };

    const getClassName = (type: number) => {
        const antecipacao =
            "fc-event fc-timegrid-event-harness-inset fc-timegrid-event antecipacaoClassName";

        const substituicao =
            "fc-event fc-timegrid-event-harness-inset fc-timegrid-event substituicaoClassName";

        const reposicao =
            "fc-event fc-timegrid-event-harness-inset fc-timegrid-event reposicaoClassName";

        if (type === TipoCartaoEnum.Antecipacao) return antecipacao;
        if (type === TipoCartaoEnum.Substituicao) return substituicao;
        if (type === TipoCartaoEnum.Reposicao) return reposicao;

        return "fc-event fc-timegrid-event-harness-inset fc-timegrid-event";
    };

    // TODO - Criar enum TipoFeriado pra comparação.
    const getHolidayColor = (type: string) => {
        if (type === "N") return "#0B8043";
        if (type === "M") return "#E25E2F";
        if (type === "R") return "#449ADF";

        return "";
    };

    const checkTurn = (now: Date, params: any) => {
        const formatDate = format(now, MASK_DATE);
        const initialMorning = new Date(
            `${formatDate} ${params.turnoManhaInicio}`
        );
        const finalMorning = new Date(
            `${formatDate} ${params.turnoManhaTermino}`
        );
        const initialAfternoon = new Date(
            `${formatDate} ${params.turnoTardeInicio}`
        );
        const finalAfternoon = new Date(
            `${formatDate} ${params.turnoTardeTermino}`
        );
        const initialNight = new Date(
            `${formatDate} ${params.turnoNoiteInicio}`
        );
        const finalNight = new Date(
            `${formatDate} ${params.turnoNoiteTermino}`
        );

        if (
            initialNight.getTime() <= now.getTime() &&
            finalNight.getTime() >= now.getTime()
        ) {
            return "noite";
        }

        if (
            initialAfternoon.getTime() <= now.getTime() &&
            finalAfternoon.getTime() >= now.getTime()
        ) {
            return "tarde";
        }

        if (
            initialMorning.getTime() <= now.getTime() &&
            finalMorning.getTime() >= now.getTime()
        ) {
            return "manha";
        }

        return "bloqueado";
    };

    // eslint-disable-next-line consistent-return
    const handleOpenModalViewDetails = (id: string) => {
        if (
            disableSave === false &&
            (pathLocation[1] === Routes.MinhaAgenda ||
                pathLocation[1] === Routes.EditarAgenda)
        ) {
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Warning,
                title: "Salvar agenda",
                text: "<span style='font-weight: normal;'>Você atualizou seus cartões.<br>Salve sua agenda antes de fazer o check-in.</span>",
                isHtml: true,
                textButton: "Voltar",
                buttonCustom: true,
            });
            return;
        }

        const result = schedulesEvents.find((item) => item.id === id);
        const realizados = schedulesEvents.filter(
            (item) =>
                item.data === result?.data &&
                checkTurn(moment(item.start).toDate(), paramsAgenda) ===
                    checkTurn(moment(result.start).toDate(), paramsAgenda) &&
                item.statusCheckin ===
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.CheckinRealizado
                    )
        );

        if (realizados.length > 0) {
            setValidTurn(true);
        }

        if (
            result &&
            [
                TipoCartaoEnum.HoraLetiva,
                TipoCartaoEnum.HoraNaoLetiva,
                TipoCartaoEnum.HoraNaoLetivaFlutuante,
                TipoCartaoEnum.Esporadica,
                TipoCartaoEnum.Antecipacao,
                TipoCartaoEnum.Substituicao,
                TipoCartaoEnum.Reposicao,
                TipoCartaoEnum.AtividadesAvulsas,
                TipoCartaoEnum.HoraExtraImportacao,
                TipoCartaoEnum.HoraExtraTela,
            ].includes(result.cartaoTipo?.cartaoTipoId)
        )
            setScheduleSelected(result);
    };

    const deallocateCard = async (event: any) => {
        const clickedCard = event.extendedProps;

        if (clickedCard.tituloCartao === RECREIO) {
            return;
        }

        const cartao = [...schedulesEvents].find(
            (item) => item.id === event.id
        );

        let cartoes = [...schedulesEvents].filter(
            (item) => item.id !== cartao.id
        );

        if (isOvertimeCard(cartao)) {
            hasHourRangeExceededForOvertimeCards =
                hourRangeExceededForOvertimeCards(cartao, schedulesEvents);

            if (
                hasHourRangeExceededForOvertimeCards.exceededTomorrowCards
                    .length > 0 ||
                hasHourRangeExceededForOvertimeCards.exceededYesterdayCards
                    .length > 0
            ) {
                const exceededCards =
                    hasHourRangeExceededForOvertimeCards.exceededTomorrowCards.concat(
                        hasHourRangeExceededForOvertimeCards.exceededYesterdayCards
                    );

                const revertedStatusCards = exceededCards.map((item) => {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    return revertStatusCards(item, cartao);
                });

                const cartoesFiltered = cartoes.filter(
                    (item: any) =>
                        !revertedStatusCards.some(
                            (exceededCard) => exceededCard.id === item.id
                        )
                );

                cartoes = cartoesFiltered.concat(revertedStatusCards);
            }
            await setOvertimeAffectedCards(cartao.cartaoAgendaId, []);
            // refreshScheduleData();
            setDisableSave(false);
        }

        const dto = GenericUtils.impl<Cartao>({
            cartaoAgendaId: cartao.cartaoAgendaId,
            titulo: cartao.tituloCartao,
            cartaoTipo: cartao.cartaoTipo,
            cartaoTipoOrigem: cartao.cartaoTipoOrigem,
            contagemCargaHoraria: cartao.contagemCargaHoraria,
            tipoHora: cartao.tipoHora,
            data: undefined,
            horaInicio: undefined,
            horaFim: undefined,
            duracaoHoraAula: cartao.duracaoHoraAula,
            duracaoHoraRelogio: cartao.duracaoHoraRelogio,
            origemCartaoId: cartao.origemCartaoId,
            dataHoraCheckin: cartao.dataHoraCheckin,
            statusCheckin: cartao.statusCheckin,
            dataInicioVigencia: cartao.dataVigenciaInicio,
            dataFimVigencia: cartao.dataVigenciaFim,
            docenteId: cartao.docenteId,
            abrangencia: cartao.abrangencia,
            ensalamento: cartao.ensalamento,
            turma: cartao.turma,
            periodoSemestral: cartao.periodoSemestral,
            divisao: cartao.divisao,
            cartaoHoraExtraId: cartao.cartaoHoraExtraId,
            statusWorkflow: cartao.statusWorkflow,
            modalidade: cartao.modalidade,
        });

        const response = await CartoesService.editarCartao(instance, dto);

        if (blockActivy) {
            setOpenDialogScheduleBlock(true);
        } else if (GenericUtils.isSuccessStatus(response)) {
            event.remove();

            // remover do cash schedulesEvents que foi removida
            const cartoesCash = [...schedulesEventsCash].filter(
                (item) => item.id !== cartao.id
            );

            setScheduleEvents(cartoes);
            setScheduleEventsCash(cartoesCash);

            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "Operação realizada com sucesso",
            });
        } else {
            const error = GenericUtils.getPropsDialogError(response);
            setErrorMessage(error?.title);
            setErrorText(error?.text);
        }
    };

    const getCardStatusPill = async (cardId: number): Promise<any> => {
        const response = await axiosGetRequest(
            `/docente/v1/cartoes/${cardId}/cartaovinculado`,
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            return response.data;
        }

        return null;
    };

    const handleCardInScheduleClick = async (id?: string, event?: any) => {
        if (id) {
            const linkedCardPill = await getCardStatusPill(
                event.extendedProps.cartaoAgendaId
            );

            if (linkedCardPill) {
                const linkedCardType = linkedCardPill.cartaoTipo.cartaoTipoId;
                const linkedCardAllocationDate = linkedCardPill.data;
                setLinkedCard({
                    linkedCardType,
                    linkedCardAllocationDate,
                });
            }

            handleOpenModalViewDetails(id);
        }
    };

    function onChangeSelected() {
        if (selected.length > 0) {
            const selectTeacherId = getTeachers.find(
                (teacher) => teacher.matriculaAdp === selected[0].value
            );
            setSelectTeachers(selectTeacherId);

            if (autocompleteElement) {
                const input = autocompleteElement.children[0]
                    .children[0] as HTMLInputElement;
                input.blur();
            }
        } else {
            setSelectTeachers(undefined);
        }
    }

    const setOvertimeAffectedCards = async (
        cartaoHoraExtraId: number,
        cards: any[]
    ) => {
        const affectedCardsIds = cards.map(
            (item) => item.cartaoAgendaId
        ) as number[];

        const response = await CartoesService.setAlocacaoHoraExtra(
            instance,
            cartaoHoraExtraId,
            affectedCardsIds
        );

        if (!GenericUtils.isSuccessStatus(response)) {
            const error = GenericUtils.getPropsDialogError(response);
            setErrorMessage(error?.title);
            setErrorText(error?.text);
        }
    };

    const disableCardsByWorkBreak = (
        cards: any[],
        movedCardId: number
    ): any[] => {
        return cards.map((item) => {
            const previousCheckinStatus =
                item.statusCheckin ===
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.DesabilitadoInterjornada
                )
                    ? item.statusCheckinAnterior
                    : item.statusCheckin;

            if (
                [
                    StatusCheckinEnumLabel.get(StatusCheckinEnum.Ferias),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.LicencaNaoRemunerada
                    ),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.LicencaRemunerada
                    ),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoNacional
                    ),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoMunicipal
                    ),
                    StatusCheckinEnumLabel.get(StatusCheckinEnum.Recesso),
                ].includes(item.statusCheckin)
            ) {
                const updatedItem = {
                    ...item,
                    cartaoHoraExtraId: movedCardId,
                };
                return updatedItem;
            }

            const updatedItem = {
                ...item,
                statusCheckin: StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.DesabilitadoInterjornada
                ),
                statusCheckinAnterior: previousCheckinStatus,
                cartaoHoraExtraId: movedCardId,
            };

            return updatedItem;
        });
    };

    const revertStatusCards = (card: any, movedCard?: any): any => {
        if (
            ![
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.DesabilitadoInterjornada
                ),
            ].includes(card.statusCheckin) &&
            ((movedCard && movedCard.data === card.data) ||
                card.cartaoHoraExtraId !== movedCard?.cartaoAgendaId)
        )
            return card;

        const previousCheckinStatus =
            card.statusCheckinAnterior ||
            StatusCheckinEnumLabel.get(StatusCheckinEnum.AguardandoCheckin);

        const updatedItem = {
            ...card,
            statusCheckin: previousCheckinStatus,
            statusCheckinAnterior: null,
            cartaoHoraExtraId: null,
        };

        return updatedItem;
    };

    const updateCardsInScheduleEvents = async (cards: any[], newCard: any) => {
        // console.log("updateCardsInScheduleEvents", {
        //     cards,
        //     newCard,
        // });
        const previousScheduleEventsWithoutNewCard = schedulesEvents.filter(
            (item) => item.id !== newCard.id
        );

        const revertedStatusCards = previousScheduleEventsWithoutNewCard.map(
            (item) => {
                return cards.length === 0
                    ? item
                    : revertStatusCards(item, newCard);
            }
        );

        const updatedScheduleEvents = revertedStatusCards.map((item) => {
            const card = cards.find(
                (actualCard) =>
                    actualCard.cartaoAgendaId === item.cartaoAgendaId
            );
            return card || item;
        });

        setScheduleEvents([...updatedScheduleEvents, newCard]);
        setScheduleEventsCash((prevEvents) => {
            // Verifica se o elemento já existe no array
            const alreadyExists = prevEvents.some(
                (event) => event.id === newCard.id
            );
            if (alreadyExists) {
                return prevEvents; // Retorna o estado anterior sem alterações
            }
            return [...prevEvents, newCard]; // Adiciona o novo card
        });

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        isOvertimeCard(newCard) &&
            (await setOvertimeAffectedCards(newCard.cartaoAgendaId, cards));
    };

    const changeTitleEvent = (newCard: any) => {
        const card = [...schedulesEvents].find(
            (item) => item.id === newCard.id
        );
        const events = [...schedulesEvents].filter(
            (item) => item.id !== newCard.id
        );

        card.title = newCard.title;
        card.tituloCartao = newCard.tituloCartao;
        events.push(card);

        setScheduleEvents(events);
    };

    const handleCloseModalViewDetails = (callback?: ModalCallback) => {
        setScheduleSelected(null);
        if (callback?.data) changeTitleEvent(callback.data);
    };

    const calcMinutes = (value: string) => {
        return (
            Number(value) ||
            Number(value?.split(":")[0]) * 60 + Number(value?.split(":")[1])
        );
    };

    const validateIfCardWasMovedIntoWorkBreak = (date: Date): boolean => {
        const professor = getSelectedDocente();
        const { inicioAfastamento, finalAfastamento } = professor;

        if (!inicioAfastamento || !finalAfastamento) return false;

        const inicioIntervaloDate = new Date(`${inicioAfastamento}T00:00`);
        const finalIntervaloDate = new Date(`${finalAfastamento}T23:59`);

        return date >= inicioIntervaloDate && date <= finalIntervaloDate;
    };

    const eventToCard = (cardId: string, date: Date) => {
        if (validateIfCardWasMovedIntoWorkBreak(date)) {
            return CARD_NOT_MOVED_BY_WORKBREAK;
        }

        let cartao = schedulesEvents.find((card) => card.id === cardId);
        cartao = structuredClone(cartao);

        const minutosHoraRelogio = calcMinutes(cartao.duracaoHoraRelogio);
        const dateFinalHoraRelogio = addMinutes(date, minutosHoraRelogio);

        const startTime = StringUtils.formatDateValueStringUTC(
            date,
            MASK_TIMESTAMP
        );
        const endTime = StringUtils.formatDateValueStringUTC(
            dateFinalHoraRelogio,
            MASK_TIMESTAMP
        );

        const finalCardYear = endTime.split("T")[0].split("-")[0];
        const finalCardMonth = endTime.split("T")[0].split("-")[1];
        const finalCardDay = Number(endTime.split("T")[0].split("-")[2]) - 1;
        const finalCardTime = `${finalCardYear}-${finalCardMonth}-${(finalCardDay <
        1
            ? 1
            : finalCardDay
        )
            .toString()
            .padStart(2, "0")}T23:59`;

        const cardFinalHour =
            endTime.split("T")[1] === "00:00" ? finalCardTime : endTime;

        const convertedInitalHourToMinutes = calcMinutes(
            startTime.split("T")[1]
        );

        const convertedFinalHourToMinutes = calcMinutes("23:59");

        if (
            convertedInitalHourToMinutes >=
            convertedFinalHourToMinutes - minutosHoraRelogio
        ) {
            return "Não é possível alocar um cartão que a hora final seja maior que 23:59";
        }

        cartao.title = cartao?.title || cartao?.tituloCartao;
        cartao.data = StringUtils.formatDateValueStringUTC(date, MASK_DATE);
        cartao.start = startTime;
        cartao.end = cardFinalHour;
        cartao.horaInicio = StringUtils.formatDateValueStringUTC(
            date,
            MASK_TIME
        );
        cartao.horaFim = StringUtils.formatDateValueStringUTC(
            dateFinalHoraRelogio,
            MASK_TIME
        );

        return cartao;
    };

    const fromBacklogToSchedule = (eventCardId: string, date: Date) => {
        if (validateIfCardWasMovedIntoWorkBreak(date)) {
            return CARD_NOT_MOVED_BY_WORKBREAK;
        }

        // console.log("eventCardId", {
        //     eventCardId,
        //     date,
        // });

        const cardPai = backlog.find((dado) => {
            return dado.cartoes.find((cartaoFilho: any) => {
                return cartaoFilho.id === eventCardId;
            });
        });

        const cardFilho = cardPai?.cartoes.find(
            (cartao: any) => cartao.id === eventCardId
        );

        // console.log("fromBacklogToSchedule", {
        //     cardPai,
        //     cardFilho,
        // });

        if (!cardFilho?.duracaoHoraRelogio || !cardFilho?.duracaoHoraAula)
            return null;

        const minutosHoraRelogio = calcMinutes(cardFilho.duracaoHoraRelogio);
        const dateFinalHoraRelogio = addMinutes(date, minutosHoraRelogio);
        const minutosHoraAula = calcMinutes(cardFilho.duracaoHoraAula);

        if (
            Number.isNaN(minutosHoraRelogio) ||
            !cardFilho.duracaoHoraRelogio ||
            !cardFilho.duracaoHoraAula
        )
            return null;

        const startTime = StringUtils.formatDateValueStringUTC(
            date,
            MASK_TIMESTAMP
        );
        const endTime = StringUtils.formatDateValueStringUTC(
            dateFinalHoraRelogio,
            MASK_TIMESTAMP
        );

        const finalCardYear = endTime.split("T")[0].split("-")[0];
        const finalCardMonth = endTime.split("T")[0].split("-")[1];
        const finalCardDay = Number(endTime.split("T")[0].split("-")[2]) - 1;
        const finalCardTime = `${finalCardYear}-${finalCardMonth}-${(finalCardDay <
        1
            ? 1
            : finalCardDay
        )
            .toString()
            .padStart(2, "0")}T23:59`;

        const cardFinalHour =
            endTime.split("T")[1] === "00:00" ? finalCardTime : endTime;

        const convertedInitalHourToMinutes = calcMinutes(
            startTime.split("T")[1]
        );

        const convertedFinalHourToMinutes = calcMinutes("23:59");

        if (
            convertedInitalHourToMinutes >=
            convertedFinalHourToMinutes - minutosHoraRelogio
        ) {
            return "Não é possível alocar um cartão que a hora final seja maior que 23:59";
        }

        return {
            // EventCard
            id: eventCardId,
            title: cardFilho.title,
            start: startTime,
            end: cardFinalHour,
            editable: true,
            className: getClassName(cardPai.cartaoTipo.cartaoTipoId),
            textColor: getFontColorAtSchedule(),
            color: getBackgroundColorAtSchedule(
                cardPai.cartaoTipo.cartaoTipoId,
                cardPai.cartoes[0].cartaoTipoOrigem
                    ? cardPai.cartoes[0].cartaoTipoOrigem.cartaoTipoId
                    : 0,
                cardPai?.contagemCargaHoraria?.letiva === "S",
                cardPai?.contagemCargaHoraria?.naoLetiva === "S"
            ),
            locale: undefined,
            durationEditable: false,
            // AgendaDTO
            abrangencia: cardPai.abrangencia,
            cartaoTipo: cardPai.cartaoTipo,
            cartaoTipoOrigem: cardFilho.cartaoTipoOrigem,
            ensalamento: cardFilho.ensalamento,
            contagemCargaHoraria: cardPai.contagemCargaHoraria,
            tipoHora: cardPai?.tipoHora,
            data: StringUtils.formatDateValueStringUTC(date, MASK_DATE),
            docenteId: selectTeachers.docenteID,
            duracaoHoraAula: String(minutosHoraAula),
            duracaoHoraRelogio: String(minutosHoraRelogio),
            horaInicio: StringUtils.formatDateValueStringUTC(date, MASK_TIME),
            horaFim: StringUtils.formatDateValueStringUTC(
                dateFinalHoraRelogio,
                MASK_TIME
            ),
            cartaoAgendaId: cardFilho.cartaoId,
            origemCartaoId: cardFilho.origemCartaoId,
            periodoSemestral: cardFilho.periodoSemestral,
            tituloCartao: cardFilho.tituloCartao || cardFilho.titulo,
            turma: cardFilho.turma,
            divisao: cardFilho.divisao,
            statusCheckin: StatusCheckinEnumLabel.get(
                StatusCheckinEnum.AguardandoCheckin
            ),
            dataVigenciaInicio: cardFilho.dataVigenciaInicio,
            dataVigenciaFim: cardFilho.dataVigenciaFim,
            cartaoHoraExtraId: cardFilho.cartaoHoraExtraId,
            createdAt: cardFilho.createdAt,
            updatedAt: cardFilho.updatedAt,
            statusWorkflow: cardFilho.statusWorkflow,
            modalidade: cardFilho.modalidade,
        };
    };

    const isProfessorAway = async (
        cardTargetDate: Date,
        cardOriginalDate: string | undefined
    ): Promise<{
        isAway: boolean;
        hasError: boolean;
        targetDateIsUnavaliable: boolean;
        originalDateIsUnavaliable: boolean;
    }> => {
        const { docenteID } = getSelectedDocente();
        const validStatuses: Array<string> = [
            ProfessorStatusEnum.ATIVO as string,
        ];

        const cardOriginalDateAsDate = cardOriginalDate
            ? new Date(`${cardOriginalDate}T00:00:00`)
            : undefined;

        const professorResponse = await ProfessorService.getProfessorById(
            instance,
            docenteID
        );

        if (GenericUtils.isSuccessStatus(professorResponse)) {
            const { inicioAfastamento, finalAfastamento } =
                professorResponse.data;
            const { codigo } = professorResponse.data.status;

            return {
                isAway: !validStatuses.includes(codigo),
                hasError: false,
                targetDateIsUnavaliable:
                    cardTargetDate >=
                        new Date(`${inicioAfastamento}T00:00:00`) &&
                    cardTargetDate <= new Date(`${finalAfastamento}T23:59:00`),
                originalDateIsUnavaliable: cardOriginalDateAsDate
                    ? cardOriginalDateAsDate >=
                          new Date(`${inicioAfastamento}T00:00:00`) &&
                      cardOriginalDateAsDate <=
                          new Date(`${finalAfastamento}T23:59:00`)
                    : false,
            };
        }

        return {
            isAway: false,
            hasError: true,
            targetDateIsUnavaliable: false,
            originalDateIsUnavaliable: true,
        };
    };

    const removeMovedCardFromBacklog = (movedCardId: string): void => {
        setBacklog(
            [...backlog].map((item: any) => {
                const back = item;
                back.cartoes = item.cartoes?.filter(
                    (cartao: any) => cartao.id !== movedCardId
                );
                return back;
            })
        );
    };

    const handleDropCard = async (
        eventCardId: string,
        date?: Date,
        event?: "drop" | "receive"
    ) => {
        const originalCard =
            event === "drop"
                ? schedulesEvents.find((card) => card.id === eventCardId)
                : undefined;

        const { isAway, hasError } = await isProfessorAway(
            date ?? new Date(),
            originalCard?.data ?? undefined
        );

        if (hasError) {
            setErrorMessage(CARD_NOT_MOVED);
            setErrorText("Ocorreu um erro ao verificar o status do professor");
            return false;
        }

        if (user1.isDac === false && user1.isDocente === false) {
            setErrorMessage(CARD_NOT_MOVED);
            setErrorText("Você não tem permissão para mover cartões");
            return false;
        }

        if (!date || isNotEditableProfile) return false;

        // console.log({
        //     isAway,
        //     hasError,
        //     eventCardId,
        //     date,
        //     event,
        //     isNotEditableProfile,
        //     originalCard,
        // });

        if (blockActivy || isAway) {
            setErrorMessage(CARD_NOT_MOVED);
            setErrorText("Agenda bloqueada para edição.");
            return false;
        }

        const newCard =
            event === "drop"
                ? eventToCard(eventCardId, date)
                : fromBacklogToSchedule(eventCardId, date);

        if (!newCard) {
            setErrorMessage(CARD_NOT_MOVED);
            setErrorText("Faltam informações para mover o cartão");
            return false;
        }

        if (typeof newCard === "string") {
            setErrorMessage(CARD_NOT_MOVED);
            setErrorText(newCard);
            return false;
        }

        const validationResult: ValidationResult = await applyValidation(
            newCard,
            schedulesEvents,
            disableSave,
            holidays,
            validActivePlan,
            dataAbonos,
            selectTeachers
        );

        if (validationResult.error) {
            if (validationResult.showPromissifiedDialog) {
                try {
                    const dialogResponse = await promisifiedDialog({
                        title: "Atenção",
                        text: validationResult.message,
                        width: 400,
                        acceptButtonText: "Sim",
                        cancelButtonText: "Cancelar",
                    });
                    if (!dialogResponse) {
                        return false;
                    }
                } catch (error) {
                    return false;
                }
            } else {
                setErrorMessage(validationResult.title || CARD_NOT_MOVED);
                setErrorText(validationResult.message);
                return false;
            }
        }

        setCleanEvents(cleanEvents + 1);

        if (isOvertimeCard(newCard)) {
            hasHourRangeExceededForOvertimeCards =
                hourRangeExceededForOvertimeCards(newCard, schedulesEvents);
            const actualAffectedCards = schedulesEvents.filter(
                (card: any) => card.cartaoHoraExtraId === newCard.cartaoAgendaId
            );

            // console.log({
            //     newCard,
            //     hasHourRangeExceededForOvertimeCards,
            //     actualAffectedCards,
            // });

            if (
                hasHourRangeExceededForOvertimeCards.exceededTomorrowCards
                    .length === 0 &&
                hasHourRangeExceededForOvertimeCards.exceededYesterdayCards
                    .length === 0 &&
                actualAffectedCards.length > 0
            ) {
                const revertedActualAffectedCards = actualAffectedCards.map(
                    (card: any) => {
                        const { statusCheckinAnterior } = card;
                        return {
                            ...card,
                            statusCheckin: statusCheckinAnterior,
                            statusCheckinAnterior: null,
                            cartaoHoraExtraId: null,
                        };
                    }
                );

                const scheduleEventsWithoutRevertedActualAffectedCards =
                    schedulesEvents.filter(
                        (card: any) =>
                            !revertedActualAffectedCards.some(
                                (revertedCard: any) =>
                                    revertedCard.cartaoAgendaId ===
                                    card.cartaoAgendaId
                            ) && card.cartaoAgendaId !== newCard.cartaoAgendaId
                    );

                setScheduleEvents([
                    ...revertedActualAffectedCards,
                    newCard,
                    ...scheduleEventsWithoutRevertedActualAffectedCards,
                ]);

                setScheduleEventsCash((prevEvents) => {
                    // Verifica se o elemento já existe no array
                    const alreadyExists = prevEvents.some(
                        (eventCard) => eventCard.id === newCard.id
                    );
                    if (alreadyExists) {
                        return prevEvents; // Retorna o estado anterior sem alterações
                    }
                    return [...prevEvents, newCard]; // Adiciona o novo card
                });

                await setOvertimeAffectedCards(newCard.cartaoAgendaId, []);
            } else {
                // console.log("Entrou no else");
                const cardsToUpdate =
                    hasHourRangeExceededForOvertimeCards.exceededYesterdayCards
                        .length > 0
                        ? {
                              exceededYesterdayCards: disableCardsByWorkBreak(
                                  hasHourRangeExceededForOvertimeCards.exceededYesterdayCards,
                                  newCard.cartaoAgendaId
                              ),
                          }
                        : {
                              exceededTomorrowCards: disableCardsByWorkBreak(
                                  hasHourRangeExceededForOvertimeCards.exceededTomorrowCards,
                                  newCard.cartaoAgendaId
                              ),
                          };

                const status = await checkHolidayCard(
                    newCard,
                    holidays,
                    instance
                );

                const statusAbono = await checkAbonoCard(
                    newCard,
                    dataAbonos,
                    selectTeachers,
                    instance
                );

                if (
                    newCard.statusCheckin !== status ||
                    newCard.statusCheckin !== statusAbono
                ) {
                    const previousStatus = newCard.statusCheckin;
                    if (
                        isNationalHoliday(getEnumByLabel(status)) ||
                        isCampusHoliday(getEnumByLabel(status))
                    ) {
                        newCard.statusCheckin = status;
                        newCard.statusCheckinAnterior = previousStatus;
                    } else if (isAbono(getEnumByLabel(statusAbono))) {
                        newCard.statusCheckin = statusAbono;
                        newCard.statusCheckinAnterior = previousStatus;
                    } else {
                        newCard.statusCheckin = "Aguardando Check-in";
                        newCard.statusCheckinAnterior = previousStatus;
                    }
                }

                await updateCardsInScheduleEvents(
                    cardsToUpdate.exceededYesterdayCards ||
                        cardsToUpdate.exceededTomorrowCards,
                    newCard
                );
            }

            removeMovedCardFromBacklog(eventCardId);
            setDisableSave(false);
            return true;
        } else {
            // console.log("Entrou no else dois");
            const status = await checkHolidayCard(newCard, holidays, instance);
            // console.log({ newCard, status });

            if (
                newCard.statusCheckin === status &&
                [
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoMunicipal
                    ),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoNacional
                    ),
                    StatusCheckinEnumLabel.get(StatusCheckinEnum.Recesso),
                ].includes(status)
            ) {
                // console.log("first if");
                await updateCardsInScheduleEvents([], newCard);

                if (event === "receive") {
                    removeMovedCardFromBacklog(eventCardId);
                }

                setDisableSave(false);
                return true;
            }

            if (
                newCard.statusCheckin !== status &&
                [
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoMunicipal
                    ),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoNacional
                    ),
                    StatusCheckinEnumLabel.get(StatusCheckinEnum.Recesso),
                ].includes(status)
            ) {
                // console.log("second if", {
                //     status,
                //     newCard,
                // });

                const blockedStatus = [
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoMunicipal
                    ),
                    StatusCheckinEnumLabel.get(
                        StatusCheckinEnum.FeriadoNacional
                    ),
                    StatusCheckinEnumLabel.get(StatusCheckinEnum.Recesso),
                ];

                if (blockedStatus.includes(newCard.statusCheckin)) {
                    // console.log("second if - first if");
                    newCard.statusCheckin = status;
                    await updateCardsInScheduleEvents([], newCard);

                    if (event === "receive") {
                        removeMovedCardFromBacklog(eventCardId);
                    }

                    setDisableSave(false);
                    return true;
                }

                const cardPreviousStatus = newCard.statusCheckin;
                newCard.statusCheckin = status;
                newCard.statusCheckinAnterior = cardPreviousStatus;
                await updateCardsInScheduleEvents([], newCard);

                if (event === "receive") {
                    removeMovedCardFromBacklog(eventCardId);
                }

                setDisableSave(false);
                return true;
            }

            if (event === "drop" && newCard.cartaoAgendaId === undefined) {
                // console.log("third if");
                const cardPreviousStatus = newCard.statusCheckin;
                newCard.statusCheckin = status;
                newCard.statusCheckinAnterior = cardPreviousStatus;
                await updateCardsInScheduleEvents([], newCard);
                removeMovedCardFromBacklog(eventCardId);
                setDisableSave(false);
                return true;
            }

            if (event === "drop" && newCard.cartaoAgendaId !== undefined) {
                // console.log(
                //     "third if",
                //     event === "drop" && newCard.cartaoAgendaId !== undefined
                // );
                const response =
                    await CartoesService.getCardLastStatusFromBackend(
                        instance,
                        newCard.cartaoAgendaId
                    );

                if (GenericUtils.isSuccessStatus(response)) {
                    const lastStatus = StatusCheckinEnumLabel.get(
                        response?.data
                    );
                    const cardPreviousStatus = newCard.statusCheckin;
                    newCard.statusCheckin = lastStatus;
                    newCard.statusCheckinAnterior = cardPreviousStatus;
                    await updateCardsInScheduleEvents([], newCard);
                    removeMovedCardFromBacklog(eventCardId);
                    setDisableSave(false);
                    return true;
                }
            }
        }

        if (event === "receive") {
            removeMovedCardFromBacklog(eventCardId);
        }

        await updateCardsInScheduleEvents([], newCard);

        setDisableSave(false);
        return true;
    };

    const isEditableCard = (cartaoTipoId: TipoCartaoEnum) => {
        if (pathLocation[1] === Routes.EditarAgenda)
            return cartaoTipoId !== TipoCartaoEnum.HoraLetiva;

        if (pathLocation[1] === Routes.ConsultarAgenda)
            return isMyProfile && cartaoTipoId !== TipoCartaoEnum.HoraLetiva;

        if (blockActivy) {
            return false;
        }

        if (selectTeachers?.matriculaAdp === user?.docente?.matriculaAdp)
            return cartaoTipoId !== TipoCartaoEnum.HoraLetiva;

        return false;
    };

    const agendaDtoToEventCard = (data: AgendaDTO) => {
        return {
            // EventCard
            title: data.tituloCartao,
            start: `${data.data}T${data.horaInicio}`,
            end: `${data.data}T${data.horaFim}`,
            id: uuid(),
            editable: isEditableCard(data.cartaoTipo?.cartaoTipoId),
            className: getClassName(data.cartaoTipo?.cartaoTipoId),
            textColor: getFontColorAtSchedule(),
            color: getBackgroundColorAtSchedule(
                data.cartaoTipo?.cartaoTipoId,
                data.cartaoTipoOrigem ? data.cartaoTipoOrigem.cartaoTipoId : 0,
                data?.contagemCargaHoraria?.letiva === "S",
                data?.contagemCargaHoraria?.naoLetiva === "S"
            ),
            durationEditable: false,
            locale: data?.ensalamento?.ensalamentoDescricao,
            // AgendaDTO
            abrangencia: data.abrangencia,
            cartaoAgendaId: data.cartaoAgendaId,
            cartaoTipo: data.cartaoTipo,
            cartaoTipoOrigem: data.cartaoTipoOrigem,
            contagemCargaHoraria: data.contagemCargaHoraria,
            tipoHora: data?.tipoHora,
            data: data.data,
            divisao: data.divisao,
            docenteId: data.docenteId,
            duracaoHoraAula: data.duracaoHoraAula,
            duracaoHoraRelogio: data.duracaoHoraRelogio,
            ensalamento: data.ensalamento,
            horaFim: data.horaFim,
            horaInicio: data.horaInicio,
            dataHoraCheckIn: data.dataHoraCheckIn,
            origemCartaoId: data.origemCartaoId,
            periodoSemestral: data.periodoSemestral,
            tituloCartao: data.tituloCartao,
            turma: data.turma,
            statusCheckin: data.statusCheckin,
            statusCheckinAnterior: data.statusCheckinAnterior,
            motivoJustificativa: data.motivoJustificativa,
            dataVigenciaInicio: data.dataVigenciaInicio,
            dataVigenciaFim: data.dataVigenciaFim,
            cartaoHoraExtraId: data.cartaoHoraExtraId,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
            statusWorkflow: data.statusWorkflow,
            modalidade: data.modalidade,
        };
    };

    async function getSchedule(matriculaAdp: string) {
        const newData = [...RECREATION];

        const response = await ScheduleService.getSchedule(
            initialDate,
            finalDate,
            matriculaAdp,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response?.data?.map((data: AgendaDTO) =>
                newData.push(agendaDtoToEventCard(data))
            );

            setScheduleEvents(newData);
        }
    }

    async function getParametrosCheckin() {
        const response = await axiosGetRequest(
            `/docente/v1/parametros-checkin`,
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setParamsAgenda(response.data);
        }
    }

    async function getVingenciaAtiva() {
        const response = await axiosGetRequest(
            `/docente/v1/vigencias-plano-atividade?data=${moment().format(
                "YYYY-MM-DD"
            )}`,
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setVigencia(response.data.vigencias);
        }
    }

    async function getActivityPlan(matriculaAdp: string) {
        const currentDay = DateUtils.formatDateToString(new Date());

        const response = await ActivityPlanService.getInvalidActivityPlan(
            currentDay,
            finalDate,
            matriculaAdp,
            instance
        );

        const blockValidites = Array<any>();

        if (response && Array.isArray(response.data)) {
            response.data.forEach((element: any) => {
                if (
                    element.planoAtividadeStatusIdAtual
                        ?.planoAtividadeStatusId ===
                        PlanoAtividadeStatusEnum.Finalizado ||
                    element.planoAtividadeStatusIdAtual
                        ?.planoAtividadeStatusId ===
                        PlanoAtividadeStatusEnum.Inconsistente
                )
                    blockValidites.push(element.vigenciaPlanoAtividade);
            });
        }

        setValidActivyPlan(blockValidites);
        if (blockValidites.length > 0) {
            setOpenDialogScheduleBlock(true);
            setBlockByAfastamento(false);
            setBlockActivity(true);
        } else {
            setBlockActivity(false);
        }
    }

    async function getDataAbonoAdministrativo() {
        const newData: any[] = [];

        const abono = await axiosGetRequest(
            `/docente/v1/calendarios?dataRange=${initialDate}...${finalDate}`,
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(abono)) {
            abono?.data?.calendarios?.forEach(async (data: any) => {
                const response = await axiosGetRequest(
                    `/docente/v1/calendarioabonoadministracoes/${data.calendarioId}`,
                    acessToken,
                    instance
                );

                if (response) {
                    const tempHoliday: any = {
                        id: response.data?.calendarioId,
                        type: response.data?.tipo,
                        name: response.data?.nome,
                        campus: response.data?.campus?.id,
                        title: response.data?.nome,
                        date: response?.data.data,
                        centroResultadoId:
                            // eslint-disable-next-line prettier/prettier
                            response.data?.centroResultados[0].centroResultado
                                .id,
                        // eslint-disable-next-line prettier/prettier
                        todosProfessores:
                            response?.data?.centroResultados[0].todoProfessor,
                        docentes: response?.data?.centroResultados[0].docentes,
                        diaInteiro: response?.data?.diaInteiro,
                        horaInicio: response?.data?.horaInicio,
                        horaFim: response?.data?.horaFim,
                    };
                    newData.push(tempHoliday);
                }
            });
            setDataAbonos(newData);
        }
    }
    async function getHolidays() {
        const response = await HolidayService.getHolidays(
            initialDate,
            finalDate,
            instance
        );

        const newData = new Array<any>();

        if (GenericUtils.isSuccessStatus(response)) {
            response.data?.map((data: any) =>
                newData.push({
                    title:
                        data.nomeFeriado +
                        (data.tipoFeriado === "M" || data.tipoFeriado === "R"
                            ? ` - ${data.campus}`
                            : ""),
                    start: data.dataFeriado,
                    end: data.dataFeriado,
                    id: data.calendarioFeriadoId,
                    color: getHolidayColor(data.tipoFeriado),
                    type: data.tipoFeriado,
                    description: data.motivoRecesso,
                    campus: data.campus,
                })
            );
        }

        setHolidays(newData);
    }

    function removeAllocatedBacklogCard(list: any[]) {
        const idEvents = schedulesEvents
            .map((item) => item.id)
            ?.filter((item) => item);
        const cartaoAgendaIdEvents = schedulesEvents
            .map((item) => item.cartaoAgendaId)
            ?.filter((item) => item);

        return list.map((item) => {
            const b = item;
            b.cartoes = item.cartoes.filter(
                (c: any) =>
                    !cartaoAgendaIdEvents.includes(c.cartaoId) &&
                    !idEvents.includes(c.id)
            );
            return b;
        }) as any[];
    }

    async function getBacklog(refreshBacklog?: boolean) {
        const response = await ScheduleService.getScheduleBacklogs(
            initialDate,
            finalDate,
            getMatriculaAdp(),
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            let listBacklog = response?.data?.map((data: any) => {
                return {
                    // EventCard
                    id: uuid(),
                    nome: data.tituloCartao,
                    escola: data.cursoNome,
                    horas: data.numeroHorasAula,
                    title: data.tituloCartao,
                    // BacklogDTO
                    cartaoTipo: data.cartaoTipo,
                    contagemCargaHoraria: data.contagemCargaHoraria,
                    tipoHora: data.tipoHora,
                    tituloCartao: data.tituloCartao,
                    abrangencia: data.abrangencia,
                    modalidade: data.modalidade,
                    cursoNome: data.cursoNome,
                    numeroHorasAula: data.numeroHorasAula,
                    cartoes: data?.cartoes?.map((item: CartaoDTO) => {
                        return {
                            // EventCard
                            id: uuid(),
                            title: item.titulo,
                            horas:
                                calcMinutes(item.duracaoHoraAula) >= 60
                                    ? "1"
                                    : "0.5",
                            className: getClassName(
                                data.cartaoTipo.cartaoTipoId
                            ),
                            textColor: getFontColor(
                                data.cartaoTipo.cartaoTipoId
                            ),
                            color: getBackgroundColor(
                                data.cartaoTipo.cartaoTipoId
                            ),
                            duration: item.duracaoHoraRelogio,
                            // CartaoDTO
                            cartaoId: item.cartaoId,
                            origemCartaoId: item.origemCartaoId,
                            duracaoHoraAula: item.duracaoHoraAula,
                            duracaoHoraRelogio: item.duracaoHoraRelogio,
                            turma: item.turma,
                            periodoSemestral: item.periodoSemestral,
                            divisao: item.divisao,
                            dataVigenciaInicio: item.dataVigenciaInicio,
                            dataVigenciaFim: item.dataVigenciaFim,
                            titulo: item.titulo,
                            cartaoTipoId: data.cartaoTipo.cartaoTipoId,
                            cartaoTipoOrigem: item.cartaoTipoOrigem,
                            ensalamento: item.ensalamento,
                            cartaoHoraExtraId: item.cartaoHoraExtraId,
                            statusWorkflow: item.statusWorkflow,
                            createdAt: item.createdAt,
                            updatedAt: item.updatedAt,
                            modalidade: item.modalidade,
                        };
                    }),
                };
            });

            if (!refreshBacklog) {
                const lista = listBacklog.filter((b: any) =>
                    [
                        TipoCartaoEnum.HoraNaoLetiva,
                        TipoCartaoEnum.HoraNaoLetivaFlutuante,
                    ].includes(b.cartaoTipo?.cartaoTipoId)
                );
                setCashBacklog(lista);
            } else {
                const backlogIntrajornada = backlog.filter(
                    (item) =>
                        item.cartaoTipo?.cartaoTipoId ===
                        TipoCartaoEnum.Intrajornada
                );

                const backlogFiltered = listBacklog.filter(
                    (b: any) =>
                        ![
                            TipoCartaoEnum.HoraNaoLetiva,
                            TipoCartaoEnum.HoraNaoLetivaFlutuante,
                        ].includes(b.cartaoTipo?.cartaoTipoId)
                );

                const backlogConcat = cashBacklog
                    .concat(backlogFiltered)
                    .concat(backlogIntrajornada);

                const backlogFinal = removeAllocatedBacklogCard(backlogConcat);

                listBacklog = backlogFinal;
            }

            setBacklog(
                listBacklog.sort((a: any, b: any) =>
                    a.tituloCartao.localeCompare(b.tituloCartao)
                )
            );

            return listBacklog;
        }

        return [];
    }

    async function getActiveTeachers() {
        const newTeachers: any[] = [];
        const response = await axiosGetRequest(
            "/docente/v1/professores?_limit=500000&horasTotais=false",
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response?.data?.map((data: any) =>
                newTeachers.push({
                    value: data.matriculaAdp,
                    label: data.nome,
                    docenteId: data.docenteId,
                })
            );

            setGetTeachers(response?.data);
            setTeachers(newTeachers);
        }
    }

    async function getNotifications(matriculaAdp: string) {
        if (pathLocation[1] === Routes.ConsultarAgenda) return;

        const tipos: TipoNotificacaoEnum[] = [
            TipoNotificacaoEnum.AtualizacaoDeHorasLetivaRe,
            TipoNotificacaoEnum.AtualizacaoAgendaDocente,
        ];

        const requests = tipos.map((tipo) =>
            NotificationService.getNotifications(matriculaAdp, tipo, instance)
        );

        const responses = await Promise.all(requests);

        const todasAsNotificacoes: { assunto: string; mensagem: string }[] = [];

        let popUpImportacaoDisparado = false;

        responses.forEach((response) => {
            if (
                GenericUtils.isSuccessStatus(response) &&
                response?.data?.length > 0
            ) {
                response.data.forEach((item: any) => {
                    todasAsNotificacoes.push({
                        assunto: item.assunto,
                        mensagem: item.mensagem,
                    });
                });

                popUpImportacaoDisparado = true;
            }
        });

        if (!popUpImportacaoDisparado) {
            const backlogData = await getBacklog();

            const hasHoraLetivaWithCartoes =
                Array.isArray(backlogData) &&
                backlogData.some(
                    (item: any) =>
                        item?.cartaoTipo?.cartaoTipoId === 11 &&
                        Array.isArray(item.cartoes) &&
                        item.cartoes.length > 0
                );

            if (hasHoraLetivaWithCartoes) {
                const evitaPopUpDuplicado = todasAsNotificacoes.some(
                    (notificacao) => notificacao.assunto === "Horas Letivas RE"
                );

                if (evitaPopUpDuplicado) return;

                todasAsNotificacoes.push({
                    assunto: "Horas Letivas RE",
                    mensagem:
                        "Foram disponibilizados em sua AGENDA os cartões de Hora Letiva RE para realizar a alocação.",
                });
            }
        }

        if (todasAsNotificacoes.length > 0) {
            setNotifications(todasAsNotificacoes);
        }
    }

    async function getCoordinations() {
        const newTeachers: any[] = [];
        const response = await axiosGetRequest(
            `docente/v1/professores?_limit=500000&horasTotais=false&matricula_coordenador=${user?.docente?.matriculaAdp}`,
            acessToken,
            instance
        );

        response?.data?.map((data: any) =>
            newTeachers.push({
                value: data.matriculaAdp,
                label: data.nome,
                docenteId: data.docenteId,
            })
        );

        setGetTeachers(response?.data);
        setTeachers(newTeachers);
    }

    async function patchCheckin(cardId: any): Promise<any> {
        return axiosPatchRequest(
            `/docente/v1/agendas/${cardId}`,
            {},
            acessToken,
            instance
        );
    }

    function getDatesFirstLast(
        cartao: any,
        firstDateCardsLocal: Date,
        endDateCardsLocal: Date
    ) {
        if (!cartao.dataVigenciaInicio && !cartao.dataVigenciaFim) {
            return {
                firstDateCards: new Date(`${initialDate} 00:00`),
                endDateCards: new Date(`${finalDate} 00:00`),
            };
        }

        const startDateValidity = parseISO(cartao.dataVigenciaInicio?.trim());
        const endDateValidity = parseISO(cartao.dataVigenciaFim?.trim());

        const firstDateCardsAux = isBefore(
            firstDateCardsLocal,
            startDateValidity
        )
            ? firstDateCardsLocal
            : startDateValidity;
        const endDateCardsAux = isAfter(endDateCardsLocal, endDateValidity)
            ? endDateCardsLocal
            : endDateValidity;

        return {
            firstDateCards: firstDateCardsAux,
            endDateCards: endDateCardsAux,
        };
    }

    function getFirstLastDate() {
        let firstDateCardsLocal = firstDateCards;
        let endDateCardsLocal = endDateCards;

        schedulesEvents.forEach((cartao) => {
            const retorno = getDatesFirstLast(
                cartao,
                firstDateCardsLocal,
                endDateCardsLocal
            );
            firstDateCardsLocal = retorno.firstDateCards;
            endDateCardsLocal = retorno.endDateCards;
        });

        backlog.forEach((cartao) => {
            cartao.cartoes.forEach((item: any) => {
                const retorno = getDatesFirstLast(
                    item,
                    firstDateCardsLocal,
                    endDateCardsLocal
                );
                firstDateCardsLocal = retorno.firstDateCards;
                endDateCardsLocal = retorno.endDateCards;
            });
        });

        setFirstDateCards(firstDateCardsLocal);
        setEndDateCards(endDateCardsLocal);
    }

    async function refreshScheduleData(
        isHoraLetivaWithAgendaBlocked?: boolean
    ) {
        if (!initialDate || !finalDate) return;

        setCleanEvents(cleanEvents + 1);
        setScheduleEventsCash([]);

        const matriculaAdp = getMatriculaAdp();

        await getHolidays();
        await getDataAbonoAdministrativo();
        await getParametrosCheckin();
        if (
            pathLocation[1] === Routes.MinhaAgenda ||
            Routes.EditarAgenda ||
            Routes.ConsultarAgenda
        ) {
            getNotifications(matriculaAdp);
        }
        if ((isHoraLetivaWithAgendaBlocked ?? false) === false) {
            await getActivityPlan(matriculaAdp);
        }
        await getSchedule(matriculaAdp);
        await getBacklog();
        await getVingenciaAtiva();
    }

    const handleCheckin = (cardId: any): Promise<boolean> => {
        return patchCheckin(cardId).then((response: any): boolean => {
            if (GenericUtils.isSuccessStatus(response)) {
                setOpenDialogCheckinSucess(true);
                refreshScheduleData(true);
            } else {
                setErrorMessage(
                    response?.message ||
                        response?.data?.message ||
                        "Falha ao realizar check-in"
                );
                setErrorText(
                    response?.details ||
                        response?.data?.details ||
                        ptBrTranslations.operationFailureText
                );
                return false;
            }
            return true;
        });
    };

    async function handleSaveSchedule(
        justfication?: string,
        replica?: boolean
    ) {
        const agendaSalvarDTO: AgendaSalvarDTO = {
            docenteId:
                pathLocation[1] !== Routes.MinhaAgenda
                    ? selectTeachers?.docenteID
                    : user.docente.docenteID,
            justificativa: justfication,
            replicarVigencia: replica ?? false,
            dataInicial: initialDate,
            dataFinal: finalDate,
            cartoes: schedulesEvents
                .filter((data) => data.cartaoTipo)
                .map((value) => {
                    return GenericUtils.impl<AgendaDTO>({
                        cartaoAgendaId: value.cartaoAgendaId,
                        docenteId: value.docenteId,
                        cartaoTipo: value.cartaoTipo,
                        cartaoTipoOrigem: value.cartaoTipoOrigem,
                        contagemCargaHoraria: value.contagemCargaHoraria,
                        tipoHora: value.tipoHora,
                        data: value.data,
                        duracaoHoraAula: value.duracaoHoraAula,
                        duracaoHoraRelogio: value.duracaoHoraRelogio,
                        tituloCartao: value.tituloCartao,
                        origemCartaoId: value.origemCartaoId,
                        abrangencia: value.abrangencia,
                        temEstudante: value.temEstudante,
                        ensalamento: value.ensalamento,
                        turma: value.turma,
                        periodoSemestral: value.periodoSemestral,
                        divisao: value.divisao,
                        horaInicio: value.horaInicio,
                        horaFim: value.horaFim,
                        dataHoraCheckIn: value.dataHoraCheckIn,
                        statusCheckin: value.statusCheckin,
                        statusCheckinAnterior: value.statusCheckinAnterior,
                        motivoJustificativa: value.motivoJustificativa,
                        dataVigenciaInicio: value.dataVigenciaInicio,
                        dataVigenciaFim: value.dataVigenciaFim,
                        cartaoHoraExtraId: value.cartaoHoraExtraId,
                        createdAt: value.createdAt,
                        updatedAt: value.updatedAt,
                        statusWorkflow: value.statusWorflow,
                        modalidade: value.modalidade,
                    });
                }),
            exclusoes: removedIntrajourneyCards,
        };

        const scheduleCards: any[] = agendaSalvarDTO.cartoes.map((card) => {
            return GenericUtils.impl<AgendaDTO>({
                ...card,
                dataHoraCheckIn:
                    card.dataHoraCheckIn &&
                    format(
                        parseISO(card.dataHoraCheckIn),
                        "yyyy-MM-dd'T'HH:mm:ss.SSS"
                    ),
            });
        });

        agendaSalvarDTO.cartoes = scheduleCards;

        const response = await ScheduleService.saveSchedule(
            agendaSalvarDTO,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setDisableSave(true);
            setSuccessMessage("Agenda salva");
            refreshScheduleData();
            setRemovedIntrajourneyCards([]);
        } else {
            setContentIsHtml(response?.data?.html || response?.html || false);
            setErrorMessage(
                response?.message ||
                    response?.data?.message ||
                    ptBrTranslations.operationFailureTitle
            );
            setErrorText(
                response?.details ||
                    response?.data?.details ||
                    ptBrTranslations.operationFailureText
            );
            setDisableSave(false);
        }
    }

    const handleRemoveCard = (card: any) => {
        if (blockActivy) return setOpenDialogScheduleBlock(true);

        if (card.cartaoTipoId === TipoCartaoEnum.Intrajornada)
            return removeCardIntrajornadaBacklog(card.id);

        return deletarCartao(card.cartaoId);
    };

    const handleRemoveJustifiedCard = async (
        cartaoId: number,
        justification: string
    ) => {
        const data = { justificativa: justification };
        const response = await CartoesService.deletarCartaoJustificado(
            instance,
            cartaoId,
            data
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setSuccessMessage("Cartão removido com sucesso");
            await getBacklog(true);
        } else {
            const error = GenericUtils.getPropsDialogError(response);
            setErrorMessage(error?.title);
            setErrorText(error?.text);
        }
    };

    const deletarCartao = async (cartaoId: number) => {
        const response = await CartoesService.deletarCartao(instance, cartaoId);

        if (GenericUtils.isSuccessStatus(response)) {
            setSuccessMessage("Cartão removido com sucesso");
            await getBacklog(true);
        } else {
            const error = GenericUtils.getPropsDialogError(response);
            setErrorMessage(error?.title);
            setErrorText(error?.text);
        }
    };

    const removeCardIntrajornada = async (event: any) => {
        const eventRemove = [...schedulesEvents].find(
            (item) => item.id === event.event.id
        );
        const events = [...schedulesEvents].filter(
            (item) => item.id !== event.event.id
        );

        // remover do cash schedulesEvents que foi removida
        const cartoesCash = [...schedulesEventsCash].filter(
            (item) => item.id !== event.event.id
        );

        setScheduleEvents(events);
        setScheduleEventsCash(cartoesCash);

        if (eventRemove?.cartaoAgendaId) {
            setRemovedIntrajourneyCards([
                ...removedIntrajourneyCards,
                eventRemove.cartaoAgendaId,
            ]);
        }
        event.event.remove();
        setSuccessMessage("Intrajornada removida com sucesso");
    };

    const getCartaoById = async (cartaoAgendaId: number) => {
        const response = await CartoesService.getById(instance, cartaoAgendaId);

        return GenericUtils.isSuccessStatus(response)
            ? response?.data
            : undefined;
    };

    const removeCardIntrajornadaBacklog = (id: string) => {
        const object = backlog.find(
            (item) =>
                item.cartaoTipo.cartaoTipoId === TipoCartaoEnum.Intrajornada
        );

        if (object) {
            const newState = backlog.map((item) => {
                if (
                    item.cartaoTipo.cartaoTipoId === TipoCartaoEnum.Intrajornada
                ) {
                    return {
                        ...item,
                        cartoes: item.cartoes.filter(
                            (_value: any) => _value.id !== id
                        ),
                    };
                }
                return item;
            });
            setBacklog(newState);
        }
    };

    async function refreshModalViewDetailsWithSelectedEvent() {
        if (!scheduleSelected) return;

        const vSheduleEvent = schedulesEvents.find(
            (evento) =>
                evento.cartaoAgendaId === scheduleSelected.cartaoAgendaId
        );

        if (!vSheduleEvent?.id) {
            handleCloseModalViewDetails();
            return;
        }

        const linkedCardPill = await getCardStatusPill(
            vSheduleEvent.cartaoAgendaId
        );

        if (linkedCardPill) {
            const linkedCardType = linkedCardPill.cartaoTipo.cartaoTipoId;
            const linkedCardAllocationDate = linkedCardPill.data;
            setLinkedCard({
                linkedCardType,
                linkedCardAllocationDate,
            });
        }

        handleOpenModalViewDetails(vSheduleEvent.id);
    }

    const refreshScheduleCard = async (ids: number[]) => {
        const c1: Cartao = await getCartaoById(ids[0]);
        const c2: Cartao = await getCartaoById(ids[1]);

        const refreshCards: any[] = [];
        const cards: Cartao[] = [];

        if (c1) cards.push(c1);
        if (c2) cards.push(c2);

        cards.forEach((data: Cartao) => {
            const cartao = [...schedulesEvents].find(
                (item) =>
                    Number(item.cartaoAgendaId) === Number(data.cartaoAgendaId)
            );

            if (!cartao) return;

            const refreshCard = {
                // EventCard
                title: cartao?.title,
                start: cartao?.start,
                end: cartao?.end,
                id: cartao?.id,
                editable: cartao?.editable,
                color: cartao?.color,
                textColor: cartao?.textColor,
                className: cartao?.className,
                locale: cartao?.locale,
                durationEditable: false,
                // AgendaDTO
                abrangencia: data.abrangencia,
                cartaoAgendaId: Number(data.cartaoAgendaId),
                cartaoTipo: data.cartaoTipo,
                cartaoTipoOrigem: data.cartaoTipoOrigem,
                contagemCargaHoraria: data.contagemCargaHoraria,
                tipoHora: data?.tipoHora,
                divisao: data.divisao,
                docenteId: data.docenteId,
                duracaoHoraAula: data.duracaoHoraAula,
                duracaoHoraRelogio: data.duracaoHoraRelogio,
                ensalamento: data.ensalamento,
                data: cartao.data,
                horaInicio: cartao.horaInicio,
                horaFim: cartao.horaFim,
                dataHoraCheckIn: data.dataHoraCheckin,
                origemCartaoId: data.origemCartaoId,
                periodoSemestral: data.periodoSemestral,
                tituloCartao: data.titulo,
                turma: data.turma,
                statusCheckin: data.statusCheckin,
                statusCheckinAnterior: data.statusCheckinAnterior,
                dataVigenciaInicio: data.dataInicioVigencia,
                dataVigenciaFim: data.dataFimVigencia,
                cartaoHoraExtraId: data.cartaoHoraExtraId,
                modalidade: data.modalidade,
            };

            refreshCards.push(refreshCard);
        });

        let cartoes = [...schedulesEvents].filter(
            (item) =>
                !refreshCards
                    .map((el) => el.cartaoAgendaId)
                    .includes(item.cartaoAgendaId)
        );

        cartoes = cartoes.concat(refreshCards);

        setScheduleEvents(cartoes);
    };

    function getInitialData() {
        if (getRole() && pathLocation[1] === Routes.EditarAgenda) {
            setSelected([]);
            setSelectTeachers(undefined);
            getActiveTeachers();
            setValidActivyPlan([]);
        } else if (
            getRoleConsult() &&
            pathLocation[1] === Routes.ConsultarAgenda
        ) {
            setSelected([]);
            setSelectTeachers(undefined);
            getCoordinations();
            setValidActivyPlan([]);
        } else {
            setSelectTeachers(user?.docente);
            if (pathLocation[1] === Routes.MinhaAgenda) {
                setInitialDate("");
                setFinalDate("");
                setHide(true);
                setTimeout(() => {
                    setHide(false);
                }, 500);
            }
        }
    }

    useEffect(() => {
        if (disableSave === false && schedulesEventsCash.length === 0) {
            setDisableSave(true);
        }
    }, [schedulesEventsCash]);

    useEffect(() => {
        getFirstLastDate();
    }, [backlog]);

    useEffect(() => {
        refreshModalViewDetailsWithSelectedEvent();
        getFirstLastDate();
    }, [schedulesEvents]);

    useEffect(() => {
        onChangeSelected();
    }, [selected]);

    useEffect(() => {
        getInitialData();
    }, [pathLocation[1]]);

    useEffect(() => {
        if (selectTeachers) {
            debouncedRefreshScheduleData();
        }
    }, [initialDate, finalDate, selectTeachers]);

    useEffect(() => {
        if (isMyProfile) setDisableSave(true);
        if (isNotEditableProfile || blockActivy) setDisableSave(true);
    }, [isMyProfile, isNotEditableProfile]);

    useEffect(() => {
        if (!draggableEl) return;

        // eslint-disable-next-line no-new
        const draggable = new Draggable(draggableEl, {
            itemSelector: ".fc-event",
            eventData(eventEl: any) {
                const className = eventEl.getAttribute("className");
                const id = eventEl.getAttribute("data-id");
                const title = eventEl.getAttribute("title");
                const color = eventEl.getAttribute("color");
                const textColor = eventEl.getAttribute("textColor");
                const dataSet = eventEl.getAttribute("data-duration");
                const { custom } = eventEl.dataset;

                return {
                    className,
                    id,
                    title,
                    color,
                    textColor,
                    custom,
                    create: true,
                    duration: dataSet,
                };
            },
        });

        if (GenericUtils.validaAfastamentoDocente(getSelectedDocente())) {
            setOpenDialogScheduleBlock(true);
            setBlockByAfastamento(true);
            setBlockActivity(true);
        }

        // eslint-disable-next-line consistent-return
        return () => draggable.destroy();
    }, [backlog]);

    const backlogValid =
        backlog.length > 0 ? (
            backlog.map((item) => (
                <ScheduleCards
                    id={item.id}
                    key={item.id}
                    title={adjustCardName(item.nome)}
                    subTitle={item.escola}
                    hour={item.horas}
                    cardTypeId={item.cartaoTipo.cartaoTipoId}
                    cards={item.cartoes}
                    removeCard={(card: any) => handleRemoveCard(card)}
                    removeJustifiedCard={(
                        cartaoId: number,
                        justification: string
                    ) => handleRemoveJustifiedCard(cartaoId, justification)}
                />
            ))
        ) : (
            <StyledCardEmptyResult>
                <InformationIcon />
                <span>Nenhum cartão disponível</span>
            </StyledCardEmptyResult>
        );

    const handleCloseModal = () => {
        setOpenDialogCheckinSucess(false);
    };

    const handleDisableSave = (status: boolean) => {
        setDisableSave(status);
    };
    const modalViewDetails = (
        <ModalViewDetails
            key={scheduleSelected}
            open={Boolean(scheduleSelected)}
            detail={scheduleSelected}
            finalDate={finalDate}
            params={paramsAgenda}
            onClose={handleCloseModalViewDetails}
            validView={pathLocation[1] !== Routes.ConsultarAgenda}
            validTurn={validTurn}
            setValidTurn={setValidTurn}
            handleCheckin={handleCheckin}
            blockActivy={blockActivy}
            refreshScheduleCard={refreshScheduleCard}
            edicaoAgenda={pathLocation[1] === Routes.EditarAgenda}
            docente={getSelectedDocente()}
            holidays={holidays}
            linkedCard={linkedCard}
            isSaveScheduleButtonDisabled={!disableSave}
        />
    );

    const dialogCheckinSucess = (
        <Dialog
            openModal={openDialogCheckinSucess}
            onHide={handleCloseModal}
            size="width-300"
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                Check-in realizado
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {scheduleSelected?.tituloCartao}
            </StyledModalText>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {format(new Date(), MASK_TIME)} -{" "}
                {format(new Date(), MASK_DATE_BR)}
            </StyledModalText>
            <StyledContainerButton>
                <BtnPrimary onClick={handleCloseModal}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );

    const handleCloseDialogSuccess = () => {
        setSuccessMessage("");
    };

    const dialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessage)}
            title={successMessage}
            onClose={handleCloseDialogSuccess}
        />
    );

    const convetHoursToFloat = (hours: string) => {
        const [hour, minutes] = hours.split(":");
        return `${parseFloat(hour)}${parseFloat(minutes) > 0 ? "." : ""}${
            parseFloat(minutes) > 0 ? parseFloat(minutes) : ""
        }`;
    };

    const setIntrajornada = (value: any) => {
        const object = backlog.find(
            (item) =>
                item.cartaoTipo.cartaoTipoId === TipoCartaoEnum.Intrajornada
        );
        if (object) {
            const newState = backlog.map((item) => {
                if (
                    item.cartaoTipo.cartaoTipoId === TipoCartaoEnum.Intrajornada
                )
                    return { ...item, cartoes: [...item.cartoes, value] };

                return item;
            });
            setBacklog(newState);
        } else {
            setBacklog([
                {
                    nome: getLabelTipoCartaoEnum(TipoCartaoEnum.Intrajornada),
                    id: uuid(),
                    cartoes: [value],
                    horas: 0,
                    tituloCartao: getLabelTipoCartaoEnum(
                        TipoCartaoEnum.Intrajornada
                    ),
                    cartaoTipo: {
                        cartaoTipoId: TipoCartaoEnum.Intrajornada,
                        cartaoTipoNome: getLabelTipoCartaoEnum(
                            TipoCartaoEnum.Intrajornada
                        ),
                    },
                    tipoHora: {
                        tipoHoraId: TipoHoraEnum.Normal,
                        tipoHoraDescricao: TipoHoraEnumLabel.get(
                            TipoHoraEnum.Normal
                        ),
                    },
                },
                ...backlog,
            ]);
        }
        setSuccessMessage("Intrajornada cadastrada com sucesso");
    };

    const handleCloseModalCreateCard = async (callback?: ModalCallback) => {
        setOpenModalCreateCard(false);

        if (!callback?.success || !callback?.data) return;

        if (callback?.data?.typeCard === TipoCartaoEnum.Intrajornada) {
            setIntrajornada({
                id: uuid(),
                title: callback.data.dataCard.title,
                horas: convetHoursToFloat(
                    callback.data.dataCard.duracaoHoraAula
                ),
                duration: callback.data.dataCard.duracaoHoraAula,
                duracaoHoraAula: callback.data.dataCard.duracaoHoraAula,
                duracaoHoraRelogio: callback.data.dataCard.duracaoHoraAula,
                className: getClassName(TipoCartaoEnum.Intrajornada),
                textColor: getFontColor(TipoCartaoEnum.Intrajornada),
                color: getBackgroundColor(TipoCartaoEnum.Intrajornada),
                tituloCartao: callback.data.dataCard.title,
                dataVigenciaInicio: format(firstDateCards, MASK_DATE),
                dataVigenciaFim: format(endDateCards, MASK_DATE),
                cartaoTipoId: TipoCartaoEnum.Intrajornada,
            });
            return;
        }

        if (
            callback?.data?.typeCard === TipoCartaoEnum.Antecipacao ||
            callback?.data?.typeCard === TipoCartaoEnum.Substituicao ||
            callback?.data?.typeCard === TipoCartaoEnum.Reposicao ||
            callback?.data?.typeCard === TipoCartaoEnum.AtividadesAvulsas ||
            callback?.data?.typeCard === TipoCartaoEnum.HoraExtraTela
        ) {
            await getBacklog(true);
        }
    };

    const handleCloseModalHourExtract = () => {
        setOpenModalHourExtract(false);
    };

    const handleOpenModalRequestJustification = () => {
        setOpenModalRequestJustification(true);
    };

    const handleOpenDialogQuestionSave = async () => {
        setSobreposto(false);
        setScheduleHasSpecialCards(false);
        const specialCardsTypes = [
            TipoCartaoEnum.Esporadica,
            TipoCartaoEnum.Antecipacao,
            TipoCartaoEnum.Substituicao,
            TipoCartaoEnum.Reposicao,
            TipoCartaoEnum.AtividadesAvulsas,
            TipoCartaoEnum.HoraExtraTela,
            TipoCartaoEnum.HoraExtraImportacao,
        ];

        schedulesEvents.forEach((item) => {
            if (item.cartaoAgendaId) {
                const testeSobre = schedulesEvents.find(
                    (item2) =>
                        (moment(`${item2.data} ${item2.horaInicio}`).isBetween(
                            moment(`${item.data} ${item.horaInicio}`),
                            moment(`${item.data} ${item.horaFim}`)
                        ) ||
                            `${item2.data} ${item2.horaInicio}` ===
                                `${item.data} ${item.horaInicio}`) &&
                        item2.cartaoAgendaId !== item.cartaoAgendaId
                );
                if (testeSobre) {
                    setSobreposto(true);
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }

            if (item.cartaoTipo) {
                const hasSpecialCard = specialCardsTypes.includes(
                    item.cartaoTipo.cartaoTipoId
                );

                if (hasSpecialCard) {
                    setScheduleHasSpecialCards(hasSpecialCard);
                    // eslint-disable-next-line no-useless-return, sonarjs/no-redundant-jump
                    return;
                }
            }
        });
        setOpenDialogQuestionSave(true);
    };

    const handleCloseModalRequestJustification = (callback?: ModalCallback) => {
        setOpenModalRequestJustification(false);

        if (callback?.success) {
            handleSaveSchedule(callback.data, replicateValidity);
        } else {
            handleOpenDialogQuestionSave();
        }
    };

    const handleCloseDialogQuestionSave = (callback: any) => {
        setOpenDialogQuestionSave(false);

        if (callback.cancelRequest) return;

        setReplicateValidity(callback.replicarVigencia);
        if (pathLocation[1] !== Routes.MinhaAgenda) {
            handleOpenModalRequestJustification();
        } else {
            handleSaveSchedule("", Boolean(callback.replicarVigencia));
        }
    };

    const dialogQuestionSave = (
        <Dialog
            openModal={openDialogQuestionSave}
            onHide={() => {
                handleCloseDialogQuestionSave({
                    replicarVigencia: false,
                    cancelRequest: true,
                });
            }}
            size="width-300"
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                Salvar Atividades
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                Você pode salvar somente a semana ou replicar as atividades para
                o restante do semestre.
            </StyledModalText>
            <StyledContainerButton>
                <BtnPrimary
                    onClick={() => {
                        handleCloseDialogQuestionSave({
                            replicarVigencia: false,
                            cancelRequest: false,
                        });
                    }}
                >
                    Salvar para a semana
                </BtnPrimary>
            </StyledContainerButton>
            <StyledContainerButton>
                <BtnOutlinePrimary
                    disabled={sobreposto || scheduleHasSpecialCards}
                    onClick={() => {
                        handleCloseDialogQuestionSave({
                            replicarVigencia: true,
                            cancelRequest: false,
                        });
                    }}
                >
                    Salvar para o semestre
                </BtnOutlinePrimary>
            </StyledContainerButton>
            <StyledContainerButton>
                <DefaultButtonLink
                    onClick={() => {
                        handleCloseDialogQuestionSave({
                            replicarVigencia: false,
                            cancelRequest: true,
                        });
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerButton>
        </Dialog>
    );

    const dialogScheduleBlock = (
        <ModalScheduleBlock
            blockByAfastamento={blockByAfastamento}
            // isOpen
            isOpen={openDialogScheduleBlock}
            onHide={() => setOpenDialogScheduleBlock(false)}
        />
    );

    const dialogScheduleIcons = (
        <Dialog
            openModal={openDialogScheduleIcons}
            onHide={() => setOpenDialogScheduleIcons(false)}
            size="width-300"
            modalIcon={<InformationModal />}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                Atenção
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                Revise seu TACH.
            </StyledModalText>
            <StyledContainerButton>
                <BtnPrimary onClick={() => setOpenDialogScheduleIcons(false)}>
                    Ok
                </BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );

    const modalCreateCard = openModalCreateCard && (
        <ModalCreateCard
            open={openModalCreateCard}
            onClose={(callback) => handleCloseModalCreateCard(callback)}
            matriculaAdp={getMatriculaAdp()}
            docente={getSelectedDocente()}
            refreshScheduleCard={refreshScheduleCard}
            vigencia={vigencia}
            dataInicioSemana={initialDate}
            dataFimSemana={finalDate}
        />
    );

    const modalHourExtract = (
        <ModalHourExtract
            open={openModalHourExtract}
            onClose={handleCloseModalHourExtract}
            mes={new Date(dataPick).getMonth() + 1}
            ano={new Date(dataPick).getFullYear()}
            matricula={selectTeachers?.matriculaAdp}
            date={new Date(dataPick)}
        />
    );

    const dialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            text={errorText}
            onClose={() => {
                setErrorMessage("");
                setErrorText("");
                setContentIsHtml(false);
            }}
            isHtml={contentIsHtml}
        />
    );

    const routeMySchedule =
        pathLocation[1] === Routes.MinhaAgenda ||
        Routes.ConsultarAgenda ||
        Routes.EditarAgenda;

    const dialogNotifications =
        routeMySchedule &&
        notifications.map((notification, index) => (
            <DialogMessageList
                key={`${notification.assunto}-${notification.mensagem}`}
                type={TypeDialogMessageEnum.Info}
                show
                title={notification.assunto}
                content={[notification.mensagem]}
                onClose={() => {
                    const novas = [...notifications];
                    novas.splice(index, 1);
                    setNotifications(novas);
                }}
            />
        ));

    const modalRequestJustification = (
        <ModalRequestJustification
            open={openModalRequestJustification}
            onClose={handleCloseModalRequestJustification}
        />
    );

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            isHtml={dialogMessageProps.isHtml}
            textButton={dialogMessageProps.textButton}
            buttonCustom={dialogMessageProps.buttonCustom}
            onClose={() => {
                setDialogMessageProps({} as DialogMessageProps);
                getBacklog(true);
            }}
        />
    );

    // eslint-disable-next-line @typescript-eslint/ban-types
    const renderConfirmationDialog = (callback: Function) => {
        if (
            // eslint-disable-next-line no-restricted-globals, no-alert
            confirm(promptMessage) === true
        ) {
            handleDisableSave(true);
            callback();
        }
    };

    const onAutoCompleteChange = (valueSelected: any) => {
        if (
            (valueSelected.length >= 1 && selected.length === 0) ||
            pathLocation[1] === Routes.ConsultarAgenda
        ) {
            setSelected(valueSelected);
        }

        if (
            valueSelected.length === 0 &&
            pathLocation[1] !== Routes.ConsultarAgenda
        ) {
            renderConfirmationDialog(() => setSelected([]));
        }
    };

    const handleAutoCompleteClearButtonClicked = () => {
        if (pathLocation[1] !== Routes.ConsultarAgenda) {
            renderConfirmationDialog(() => setSelected([]));
            return;
        }

        setSelected([]);
    };

    const header = () => {
        if (pathLocation[1] === Routes.EditarAgenda) {
            return (
                <StyledHeader>
                    <StyledTitle>Editar Agenda</StyledTitle>
                    <StyledTitleContainer
                        style={{
                            fontSize: 17,
                            lineHeight: "25.5px",
                            marginTop: 8,
                        }}
                    >
                        Aqui você pode visualizar as agendas e editar ou criar
                        atividades para os professores.
                    </StyledTitleContainer>
                    <StyledTitleContainer
                        style={{
                            fontSize: 17,
                            lineHeight: "21.37px",
                            paddingTop: 32,
                        }}
                    >
                        Selecione o professor cuja agenda deseja visualizar
                    </StyledTitleContainer>
                    <div className="selectTeacher" style={{ display: "flex" }}>
                        <Autocomplete
                            onChange={onAutoCompleteChange}
                            options={teachers}
                            placeholder="Selecionar professor"
                            selected={selected}
                            customClearFunction={
                                handleAutoCompleteClearButtonClicked
                            }
                        />
                    </div>
                </StyledHeader>
            );
        }

        if (pathLocation[1] === Routes.ConsultarAgenda) {
            return (
                <StyledHeader>
                    <StyledTitle>Consultar Agenda</StyledTitle>

                    <StyledTitleContainer
                        style={{
                            fontSize: 17,
                            lineHeight: "25.5px",
                            marginTop: 8,
                        }}
                    >
                        Navegue entre os meses para conferir e/ou organizar
                        atividades.
                    </StyledTitleContainer>
                    <StyledTitleContainer
                        style={{
                            fontSize: 17,
                            lineHeight: "21.37px",
                            paddingTop: 32,
                        }}
                    >
                        Selecione o professor cuja agenda deseja visualizar
                    </StyledTitleContainer>
                    <div className="selectTeacher" style={{ display: "flex" }}>
                        <Autocomplete
                            onChange={onAutoCompleteChange}
                            options={teachers}
                            placeholder="Selecionar professor"
                            selected={selected}
                            extraOptions
                            customClearFunction={
                                handleAutoCompleteClearButtonClicked
                            }
                        />
                    </div>
                </StyledHeader>
            );
        }

        return (
            <StyledHeader>
                <StyledTitle>Minha Agenda</StyledTitle>
                <StyledTitleContainer
                    style={{
                        fontSize: 17,
                        lineHeight: "25.5px",
                        marginTop: 8,
                        marginBottom: 0,
                    }}
                >
                    Navegue entre os meses para conferir e/ou organizar
                    atividades.
                </StyledTitleContainer>
            </StyledHeader>
        );
    };

    const isCardsProfile = () => {
        const [isExpanded, setIsExpanded] = useState(true);
        const cardsAvailable =
            Array.isArray(backlog) &&
            backlog.some((item) => item.cartoes?.length > 0);

        const toggleExpand = () => {
            setIsExpanded((prev) => !prev);
        };

        if (pathLocation[1] !== Routes.ConsultarAgenda || !blockActivy) {
            return (
                <>
                    {modalCreateCard}
                    <StyledExternalEvents
                        id="external-events"
                        isExpanded={isExpanded}
                    >
                        <StyledActivityHeaderDiv isExpanded={isExpanded}>
                            <StyledHeaderRow>
                                {isExpanded && (
                                    <StyledBacklogTitleContainer>
                                        <StyledBacklogTitle>
                                            Atividades para alocação
                                        </StyledBacklogTitle>
                                    </StyledBacklogTitleContainer>
                                )}

                                {isExpanded ? (
                                    <ToggleExpandButtonRight
                                        onClick={
                                            !cardsAvailable
                                                ? toggleExpand
                                                : undefined
                                        }
                                        disabled={cardsAvailable}
                                    >
                                        <LeftArrow
                                            style={{ fill: "#404040" }}
                                        />
                                    </ToggleExpandButtonRight>
                                ) : (
                                    <ToggleExpandButtonCenter
                                        onClick={
                                            !cardsAvailable
                                                ? toggleExpand
                                                : undefined
                                        }
                                        disabled={cardsAvailable}
                                    >
                                        <RightArrow
                                            style={{ fill: "#404040" }}
                                        />
                                    </ToggleExpandButtonCenter>
                                )}
                            </StyledHeaderRow>
                            <StyledBacklogPhraseContainer>
                                {isExpanded && (
                                    <StyledBacklogPhrase>
                                        Arraste os cartões para o horário
                                        desejado
                                    </StyledBacklogPhrase>
                                )}
                            </StyledBacklogPhraseContainer>
                        </StyledActivityHeaderDiv>
                        {isExpanded ? (
                            <StyledBacklogDiv>
                                {viewType === "timeGridWeek" ? (
                                    backlogValid
                                ) : (
                                    <StyledScheduleDiv>
                                        <InformationIcon
                                            style={{
                                                fill: "#404040",
                                                marginRight: 10,
                                            }}
                                        />
                                        <StyledTitleContainer
                                            style={{
                                                fontSize: 10,
                                                lineHeight: "120%",
                                            }}
                                        >
                                            Os cartões de atividades estão
                                            disponíveis na visualização semanal
                                        </StyledTitleContainer>
                                    </StyledScheduleDiv>
                                )}
                            </StyledBacklogDiv>
                        ) : (
                            <StyledBacklogDiv>
                                {!cardsAvailable && isExpanded && (
                                    <StyledCardEmptyResult>
                                        <InformationIcon />
                                        <span>Nenhum cartão disponível</span>
                                    </StyledCardEmptyResult>
                                )}
                            </StyledBacklogDiv>
                        )}
                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: "95%",
                                height: 100,
                                paddingBottom: 5,
                            }}
                        >
                            {isExpanded && (user1.isDac || user1.isDocente) && (
                                <BtnOutlinePrimary
                                    disabled={
                                        pathLocation[1] ===
                                            Routes.ConsultarAgenda ||
                                        blockByAfastamento
                                    }
                                    onClick={() => {
                                        setOpenModalCreateCard(true);
                                    }}
                                >
                                    Criar cartão
                                </BtnOutlinePrimary>
                            )}
                        </div>
                    </StyledExternalEvents>
                </>
            );
        }

        return null;
    };

    const headerView = header();
    const cardsView = isCardsProfile();

    const formatedDate = (date: any) => {
        return moment(date).format("DD/MM/YYYY");
    };

    const handleCloseModalReport = () => {
        setReportDialog(false);
    };

    const openModalReport = (
        <ModalReport
            open={reportDialog}
            onClose={handleCloseModalReport}
            info={selectTeachers?.docenteID}
            initialDate={formatedDate(initialDate)}
        />
    );

    const generateReport = viewType === "timeGridWeek" && (
        <StyledExtractButton
            onClick={() => {
                setReportDialog(true);
            }}
        >
            <PrintReportIcon />
            Gerar relatório
        </StyledExtractButton>
    );

    useEffect(() => {
        const unloadCallback = (event: any) => {
            event.preventDefault();
            // eslint-disable-next-line no-param-reassign
            event.returnValue = "";
            return "";
        };

        window.addEventListener("beforeunload", unloadCallback);

        return () => {
            // window.addEventListener("popstate", unloadCallback);
            window.removeEventListener("beforeunload", unloadCallback);
        };
    }, []);

    return (
        <ThemeProvider theme={theme}>
            {headerView}

            {selectTeachers && (
                <>
                    <div className="d-flex justify-content-end">
                        <StyledExtractButton
                            onClick={() => {
                                setOpenModalHourExtract(true);
                            }}
                        >
                            <FileExtractIcon />
                            Ver extrato mensal de horas/aula
                        </StyledExtractButton>
                        {pathLocation[1] === Routes.EditarAgenda &&
                            generateReport}
                    </div>
                    {openModalHourExtract && modalHourExtract}
                    {reportDialog && openModalReport}
                    <StyledBody style={{ display: "flex", width: "100%" }}>
                        {cardsView}
                        <StyledScheduleContainer>
                            <Schedule
                                dataSchedule={schedulesEvents}
                                holidays={holidays}
                                viewType={viewType}
                                clean={cleanEvents}
                                setViewType={setViewType}
                                setInitialDate={setInitialDate}
                                setFinalDate={setFinalDate}
                                viewDetails={(id, event) =>
                                    handleCardInScheduleClick(id, event)
                                }
                                onDrop={handleDropCard}
                                disabledSchedule={blockActivy}
                                onRemoveIntrajornada={removeCardIntrajornada}
                                onDeallocateCard={deallocateCard}
                                onDate={(e) => {
                                    setDataPick(e);
                                }}
                                blockActivy={blockActivy}
                                hide={hide}
                                handleDisableSave={handleDisableSave}
                            />
                            {pathLocation[1] !== Routes.ConsultarAgenda &&
                                !blockActivy &&
                                (user1.isDac || user1.isDocente) && (
                                    <ButtonWrapper>
                                        <BtnPrimary
                                            disabled={disableSave}
                                            onClick={
                                                handleOpenDialogQuestionSave
                                            }
                                        >
                                            Salvar agenda
                                        </BtnPrimary>
                                    </ButtonWrapper>
                                )}
                        </StyledScheduleContainer>
                    </StyledBody>
                    {!!notifications.length && dialogNotifications}
                    {scheduleSelected && modalViewDetails}
                    {openModalRequestJustification && modalRequestJustification}
                    {openDialogQuestionSave && dialogQuestionSave}
                    {successMessage && dialogSuccess}
                    {errorMessage && dialogError}
                    {dialogCheckinSucess}
                    {dialogScheduleBlock}
                    {dialogScheduleIcons}
                    {dialogMessage}
                </>
            )}
            <Prompt when={!disableSave} message={promptMessage} />
        </ThemeProvider>
    );
}

export default ScheduleView;
